import { USER_AUTH_STATUS_LABEL } from "@/constants/enum";

/**
 * Gets the Vietnamese label for a user authentication status.
 *
 * @param {string} status - The authentication status in Japanese.
 * @returns {string} - The Vietnamese label for the status, or the original status if not found.
 */
export const getAuthStatusLabel = (status: string | null | undefined): string => {
  if (!status) return "";
  return USER_AUTH_STATUS_LABEL[status] || status;
};
